// extracted by mini-css-extract-plugin
export default {"more":"more_ik_GG","hiddenCursor":"hiddenCursor_Sjch9","staticCursor":"staticCursor_NsXgA","main":"main_WpTo8","headBox":"headBox_CwI3T","toolsBox":"toolsBox_ArbyI"};